import React, { useState } from 'react';
import { Card, Form as BootstrapForm, Button, Row, Col, FloatingLabel } from 'react-bootstrap';

const FormComponent = props => {
  const {
    className,
    equipments,
    fieldChange,
    onSubmit
  } = props;

  const [serialNumberError, setSerialNumberError] = useState(false);

  // Validação do serialnumber enquanto digita
  const handleSerialNumberChange = (event) => {
    const value = event.target.value;
    fieldChange(event, 'serialnumber', value);
    
    // Exibir feedback se o valor tiver algum conteúdo e não tiver 10 caracteres
    if (value && value.length !== 10) {
      setSerialNumberError(true);
    } else {
      setSerialNumberError(false);
    }
  };

  return (
    <Card className='mt-3'>
      <Card.Body>
        <BootstrapForm>

          <Row className="mb-2 g-2">
            <Col sm={6} xs={12}>
              <FloatingLabel
                controlId="floatingSerialNumber"
                label="Número de Série"
                className="mb-2"
              >
                <BootstrapForm.Control
                  type="text"
                  placeholder="Número de Série"
                  name="serialnumber"
                  onChange={handleSerialNumberChange}
                  value={equipments.serialnumber || ''}
                  maxLength={10}
                  required
                  isInvalid={serialNumberError}
                />
                <BootstrapForm.Control.Feedback type="invalid">
                  O número de série deve conter exatamente 10 caracteres.
                </BootstrapForm.Control.Feedback>
                <BootstrapForm.Text className="text-muted">
                  {equipments.serialnumber ? `${equipments.serialnumber.length}/10 caracteres` : '0/10 caracteres'}
                </BootstrapForm.Text>
              </FloatingLabel>
            </Col>

            <Col sm={6} xs={12}>
              <FloatingLabel
                controlId="floatingNameEquipament"
                label="Nome do Equipamento"
                className="mb-2"
              >
                <BootstrapForm.Control
                  type="text"
                  placeholder="Nome do Equipamento"
                  name="nameEquipament"
                  onChange={event =>
                    fieldChange(event, 'nameEquipament', event.target.value)
                  }
                  value={equipments.nameEquipament || ''}
                />
              </FloatingLabel>
            </Col>
          </Row>

          <Row className="mb-2 g-2">
            <Col xs={12}>
              <FloatingLabel
                controlId="floatingObservation"
                label="Observação"
                className="mb-2"
              >
                <BootstrapForm.Control
                  as="textarea"
                  placeholder="Observação"
                  name="observation"
                  onChange={event =>
                    fieldChange(event, 'observation', event.target.value)
                  }
                  value={equipments.observation || ''}
                />
              </FloatingLabel>
            </Col>
          </Row>
        </BootstrapForm>
      </Card.Body>

      <Card.Footer className="d-flex">
        <Button
          className="me-2"
          variant="success"
          onClick={() => onSubmit()}>
          Salvar
        </Button>
        <Button
          onClick={() => { window.history.back() }}
          variant="secondary"
        >
          Cancelar
        </Button>
      </Card.Footer>
    </Card>
  );
};

export default FormComponent;
